const getFromLocalStorage = (key) => {
  const { localStorage } = window
  return JSON.parse(localStorage.getItem(key))
}

const saveToLocalStorage = (key, value) => {
  const { localStorage } = window
  return localStorage.setItem(key, JSON.stringify(value))
}

const saveLocalStorageItem = (localStorageKey, key, value) => {
  const existingSettings = getFromLocalStorage(localStorageKey) || {}
  const newValues = Object.assign({}, existingSettings, { [key]: value })

  return saveToLocalStorage(localStorageKey, newValues)
}

const loadLocalStorageItem = (localStorageKey, key) => {
  const values = getFromLocalStorage(localStorageKey) || {}

  return values[key]
}

export { saveLocalStorageItem, loadLocalStorageItem }
